import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Data } from "src/app/models/data/Data.interface";
import { DataUtil } from "src/app/services/utils/data.util";

/**
 * POUR DES QUESTION DE PERFORMANCES (problème posé par pure: false)
 * toutes les methodes contenues dans displayByData doivent faire au maximum
 * l'économie de logique métier:
 * la propriété options dans "Data" est conçue pour éviter le maximum de métier dans le pipe
 * en faisant un pré-mapping lors du mapping de la réponse api au model
 */
@Pipe({
    name: 'numberTranslate', pure: false,
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(data: Data | undefined) {
    return DataUtil.displayByData(data, this.translate.currentLang());
  }
}
